/** CPF brasileiro (com ou sem pontuação) — heurística para bloquear sync de PII. */
export const BRAZILIAN_CPF_LIKE_PATTERN = /\d{3}\.?\d{3}\.?\d{3}-?\d{2}/

export const textLooksLikeBrazilianCpf = (text: string): boolean =>
  BRAZILIAN_CPF_LIKE_PATTERN.test(text)
